import vuetify, { defaults } from '@/plugins/vuetify';
import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import notification from './modules/notification';
import alert from '@/store/modules/alert';
import booking from '@/store/modules/booking';
import Cookies from 'js-cookie';
import api from '@/api';
import { checkIfHasUnreadNotification } from '@/api/notification';
import {
  syncPendingAssignmentAppointmentCount,
  syncClinicUnreadBookingCount,
  syncClinicUnreadNotificationCount,
} from '@/plugins/app-state';
import { canAccessRoute } from '@/router';
import { roles } from '@/data/constants';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    debug: !!Cookies.get('debug'),
  },
  mutations: {
    setDebug(state, val) {
      state.debug = val;
    },
  },
  actions: {},
  getters: {
    debug: state => state.debug,
  },
  modules: {
    auth,
    alert,
    notification,
    booking,
  },
});

export default store;

// let timeInterval = null;
// function syncPendingAssignmentAppointmentCountPolling() {
//   clearInterval(timeInterval);
//   timeInterval = setInterval(() => {
//     syncPendingAssignmentAppointmentCount(store, api);
//   }, 1000 * 60);
// }

// store.watch(
//   (_, getters) => getters['auth/role'],
//   async x => {
//     if (canAccessRoute('/timetable')) {
//       syncPendingAssignmentAppointmentCount(store, api);
//       syncPendingAssignmentAppointmentCountPolling();
//     } else {
//       clearInterval(timeInterval);
//       timeInterval = null;
//     }
//     store.commit(
//       'notification/setHasUnreadNotification',
//       x ? await checkIfHasUnreadNotification(api) : null,
//     );
//   },
// );

let timeInterval = null;
function syncClinicUnreadBookingCountPolling() {
  clearInterval(timeInterval);
  timeInterval = setInterval(() => {
    syncClinicUnreadBookingCount(store, api);
  }, 1000 * 30);
}

let notificationInterval = null;
function syncClinicUnreadNotificationCountPolling() {
  clearInterval(notificationInterval);
  notificationInterval = setInterval(() => {
    syncClinicUnreadNotificationCount(store, api);
  }, 1000 * 30);
}

store.watch(
  (_, getters) => getters['auth/role'],
  async x => {
    if (canAccessRoute('/timetable') && x === roles.clinicStaff) {
      syncClinicUnreadBookingCount(store, api);
      syncClinicUnreadBookingCountPolling();
    } else {
      clearInterval(timeInterval);
      timeInterval = null;
      store.commit('booking/setUnreadCount', { total: 0, unread: {}, expired: {} });
    }

    if (canAccessRoute('/notification') && x === roles.clinicStaff) {
      syncClinicUnreadNotificationCount(store, api);
      syncClinicUnreadNotificationCountPolling();
    } else {
      clearInterval(notificationInterval);
      notificationInterval = null;
      store.commit('notification/setUnreadCount', 0);
    }
  },
);
